<template>
  <div>
    <ActitiveTabcomponent
      :tabs="tabItems"
      :defaultTab="activeTab"
      @tab-changed="handleTabChange"
      @button-click="handleButtonClick"
    >
      <template #tab-buttons>
        <div v-if="activeTab === 'InventoryOrder'" class="flex space-x-2">
          <v-btn color="primary" @click="toggleshowRefillInventory">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </div>
        <div v-if="activeTab === 'InventoryStatus'" class="flex space-x-2">
          <!-- Add Inventory and Export buttons -->

          <v-btn color="primary" class="mr-2" @click="toggleshowAddInventory">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
          <v-btn color="primary" @click="toggleshowExportInventory">
            <v-icon left>mdi-download</v-icon>
            Export
          </v-btn>
        </div>
        <div v-if="activeTab === 'EmployeeInventory'" class="flex space-x-2">
          <v-btn color="primary" @click="toggleShowEmpInventory">
            <v-icon left>mdi-account-plus</v-icon>
            Assign Part
          </v-btn>
        </div>
        <div v-if="activeTab === 'OrderStatus'">
          <!-- Export button -->
          <v-btn color="primary" @click="exportProductDataToExcel">
            <v-icon left>mdi-download</v-icon>
            Export
          </v-btn>
        </div>
      </template>
      <!-- Tab Content Slots -->
      <template v-for="tab in visibleTabs" v-slot:[tab.key]="">
        <div v-if="!isLoad">
          <v-main class="" style="padding: 0px">
            <component
              :is="tab.component"
              :ref="tab.key"
              @buttons-updated="updateTabButtons"
              @button-click="handleComponentButtonClick"
              @request-add-order="handleRequestAddOrder"
              @request-edit-order="handleRequestEditOrder"
              @request-add-inventory="handleRequestAddInventory"
              @request-edit-inventory="handleRequestEditInventory"
              @request-close-add-inventory="handleRequestCloseAddInventory"
              @request-add-emp-inventory="handleRequestAddEmpInventory"
              @request-edit-emp-inventory="handleRequestEditEmpInventory"
              @request-close-add-emp-inventory="handleRequestCloseAddEmpInventory"
            />
          </v-main>
        </div>
        <div v-else class="absolute w-full h-screen flex-col items-center flex justify-center">
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>

    <!-- Add Order Dialog -->
    <v-dialog v-model="showAddOrderDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center border-b border-gray-200">
          <h3 class="form-title">
            {{ editOrderData ? 'Edit Order' : 'Add New Order' }}
          </h3>
          <v-btn icon @click="closeAddOrderDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <AddOrder
            v-if="showAddOrderDialog"
            :editData="editOrderData"
            @cancel="closeAddOrderDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add Inventory Dialog -->
    <v-dialog v-model="showAddInventoryDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center border-b border-gray-200">
          <h3 class="form-title">
            {{ editInventoryData ? 'Edit Inventory' : 'Add Inventory' }}
          </h3>
          <v-btn icon @click="closeAddInventoryDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <AddInventory
            v-if="showAddInventoryDialog"
            :inventory="editInventoryData"
            @cancel="closeAddInventoryDialog"
            @cancelUpdate="closeAddInventoryDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add Employee Inventory Dialog -->
    <v-dialog v-model="showAddEmpInventoryDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title
          class="d-flex justify-space-between align-center border-b border-gray-200 p-4"
        >
          <h3 class="form-title">
            {{ editEmpInventoryData ? 'Edit Assign' : 'Add New Assign' }}
          </h3>
          <v-btn icon @click="closeAddEmpInventoryDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <AddEmpInventory
            v-if="showAddEmpInventoryDialog"
            :innerEdit="editEmpInventoryData"
            @cancel="closeAddEmpInventoryDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InventoryOrder from '~/components/Workforce/InventoryManagement/InventoryOrder.vue'
import InventoryStatus from '~/components/Workforce/InventoryManagement/InventoryStatus.vue'
import InventoryIn from '~/components/Workforce/InventoryManagement/InventoryIn.vue'
import InventoryOut from '~/components/Workforce/InventoryManagement/InventoryOut.vue'
import EmployeeInventory from '~/components/Workforce/InventoryManagement/EmployeeInventory.vue'
import OrderStatus from '~/components/Workforce/InventoryManagement/OrderStatus.vue'
import AddOrder from '~/components/Workforce/InventorySettings/AddOrder.vue'
import AddInventory from '~/components/Workforce/InventoryManagement/AddInventory.vue'
import AddEmpInventory from '~/components/Workforce/InventoryManagement/AddEmpInventory.vue'
import { isModuleFeatureAllowed, hasPermission } from '@/utils/common'
import permissionData from '@/utils/permissions'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'

export default {
  name: 'InventoryManagement',
  layout: 'Workforce/default',
  components: {
    InventoryStatus,
    InventoryOrder,
    InventoryIn,
    InventoryOut,
    EmployeeInventory,
    OrderStatus,
    ActitiveTabcomponent,
    AddOrder,
    AddInventory,
    AddEmpInventory
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      tabs: 0,
      isLoad: true,
      tabButtons: {}, // Store buttons for each tab
      buttonHandlers: {}, // Store button handlers for each tab
      showAddOrderDialog: false,
      editOrderData: null,
      showAddInventoryDialog: false,
      editInventoryData: null,
      showAddEmpInventoryDialog: false,
      editEmpInventoryData: null
    }
  },
  computed: {
    canRead() {
      return hasPermission(this.userData, permissionData.inventoryRead)
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.inventoryWrite)
    },
    tabItems() {
      const tabItems = [
        {
          key: 'InventoryOrder',
          label: 'Refill Orders',
          icon: 'mdi-cart-plus',
          component: 'InventoryOrder',
          visible: this.canRead && this.isFeatureVisible('REFILL_INVENTORY')
        },
        {
          key: 'InventoryStatus',
          label: 'Current Status',
          icon: 'mdi-clipboard-list',
          component: 'InventoryStatus',
          visible: this.canRead && this.isFeatureVisible('CHECK_CURRENT_STOCK')
        },
        {
          key: 'EmployeeInventory',
          label: 'Part Assignment',
          icon: 'mdi-account-hard-hat',
          component: 'EmployeeInventory',
          visible: this.canRead
        },
        {
          key: 'OrderStatus',
          label: 'Spare Part Consumed',
          icon: 'mdi-package-down',
          component: 'OrderStatus',
          visible: this.canRead
        },
        {
          key: 'InventoryIn',
          label: 'Part In',
          icon: 'mdi-arrow-down-box',
          component: 'InventoryIn',
          visible: this.canRead && this.isFeatureVisible('CHECK_PRODUCT_HISTORY')
        },
        {
          key: 'InventoryOut',
          label: 'Part Out',
          icon: 'mdi-arrow-up-box',
          component: 'InventoryOut',
          visible: this.canRead && this.isFeatureVisible('CHECK_PRODUCT_HISTORY')
        }
      ]
      return tabItems
    },
    visibleTabs() {
      const filtered = this.tabItems.filter((tab) => tab.visible)
      return filtered
    },
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    defaultTabKey() {
      return this.visibleTabs.length > 0 ? this.visibleTabs[0].key : 'InventoryOrder'
    },
    currentTabButtons() {
      return this.tabButtons[this.activeTab] || []
    }
  },
  methods: {
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }

      this.$nextTick(() => {
        this.detectTabButtons(tabKey)
      })
    },

    isFeatureVisible(feature) {
      return isModuleFeatureAllowed('STOCK_MANAGEMENT', feature)
    },

    detectTabButtons(tabKey) {
      const component = this.$refs[tabKey]
      if (component && component[0]) {
        const componentInstance = component[0]

        if (componentInstance.getTabButtons) {
          const buttons = componentInstance.getTabButtons()
          this.$set(this.tabButtons, tabKey, buttons)
        } else {
          this.$set(this.tabButtons, tabKey, [])
        }
      }
    },

    getDefaultButtonsForTab(tabKey) {
      const defaultButtons = {
        InventoryOrder: [
          {
            key: 'refill-inventory',
            label: 'Refill Inventory',
            icon: 'mdi-plus',
            color: 'primary',
            class: 'white--text',
            action: 'toggleshowRefillInventory',
            visible: this.canWrite
          }
        ],
        InventoryStatus: [
          {
            key: 'add-inventory',
            label: 'Add Inventory',
            icon: 'mdi-plus',
            color: 'primary',
            class: 'white--text',
            action: 'toggleshowAddInventory',
            visible: this.canWrite
          },
          {
            key: 'export-status',
            label: 'Export',
            icon: 'mdi-download',
            color: 'primary',
            class: 'white--text',
            action: 'exportProductDataToExcel',
            visible: this.canRead
          }
        ],
        EmployeeInventory: [
          {
            key: 'assign-part',
            label: 'Assign Part',
            icon: 'mdi-account-plus',
            color: 'primary',
            class: 'white--text',
            action: 'showAssignPartDialog',
            visible: this.canWrite
          }
        ],
        OrderStatus: [
          {
            key: 'export-consumed',
            label: 'Export',
            icon: 'mdi-download',
            color: 'primary',
            class: 'white--text',
            action: 'exportConsumedData',
            visible: this.canRead
          }
        ],
        InventoryIn: [
          {
            key: 'add-part-in',
            label: 'Add Part In',
            icon: 'mdi-plus',
            color: 'primary',
            class: 'white--text',
            action: 'showAddPartInDialog',
            visible: this.canWrite
          }
        ],
        InventoryOut: [
          {
            key: 'add-part-out',
            label: 'Add Part Out',
            icon: 'mdi-plus',
            color: 'primary',
            class: 'white--text',
            action: 'showAddPartOutDialog',
            visible: this.canWrite
          }
        ]
      }

      return defaultButtons[tabKey] || []
    },

    handleButtonClick(button) {
      console.log(`Button clicked: ${button.key}`, button)

      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0][button.action]) {
        component[0][button.action]()
        return
      }

      if (button.action && this[button.action]) {
        this[button.action](button)
        return
      }

      this.$emit(`button-click`, { button, tabKey: this.activeTab })
    },

    handleComponentButtonClick(buttonData) {
      console.log('Component button click:', buttonData)
      this.$emit('component-button-click', buttonData)
    },

    updateTabButtons(tabKey, buttons) {
      this.$set(this.tabButtons, tabKey, buttons)
    },

    toggleshowRefillInventory() {
      this.showAddOrderDialog = true
      this.editOrderData = null
    },

    toggleshowAddInventory() {
      this.showAddInventoryDialog = true
      this.editInventoryData = null
    },

    exportProductDataToExcel() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].exportProductDataToExcel) {
        component[0].exportProductDataToExcel()
      }
    },

    showAssignPartDialog() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].showAssignPartDialog) {
        component[0].showAssignPartDialog()
      }
    },

    exportConsumedData() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].exportConsumedData) {
        component[0].exportConsumedData()
      }
    },

    showAddPartInDialog() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].showAddPartInDialog) {
        component[0].showAddPartInDialog()
      }
    },

    showAddPartOutDialog() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].showAddPartOutDialog) {
        component[0].showAddPartOutDialog()
      }
    },

    toggleShowEmpInventory() {
      this.showAddEmpInventoryDialog = true
      this.editEmpInventoryData = null
    },
    toggleshowExportInventory() {
      const component = this.$refs[this.activeTab]
      if (component && component[0] && component[0].toggleshowExportInventory) {
        component[0].toggleshowExportInventory()
      }
    },
    closeAddOrderDialog() {
      this.showAddOrderDialog = false
      this.editOrderData = null
      if (this.activeTab === 'InventoryOrder') {
        const component = this.$refs[this.activeTab]
        if (component && component[0] && component[0].fetchInventoryOrder) {
          component[0].fetchInventoryOrder()
        }
      }
    },
    openEditOrderDialog(orderData) {
      this.editOrderData = orderData
      this.showAddOrderDialog = true
    },

    handleRequestAddOrder() {
      this.showAddOrderDialog = true
      this.editOrderData = null
    },

    handleRequestEditOrder(orderData) {
      this.editOrderData = orderData
      this.showAddOrderDialog = true
    },
    closeAddInventoryDialog() {
      this.showAddInventoryDialog = false
      this.editInventoryData = null
      if (this.activeTab === 'InventoryStatus') {
        const component = this.$refs[this.activeTab]
        if (component && component[0] && component[0].$refs.inventoryTable) {
          component[0].$refs.inventoryTable.getDataFromApi()
        }
      }
    },

    handleRequestAddInventory() {
      this.showAddInventoryDialog = true
      this.editInventoryData = null
    },

    handleRequestEditInventory(inventoryData) {
      this.editInventoryData = inventoryData
      this.showAddInventoryDialog = true
    },

    handleRequestCloseAddInventory() {
      this.showAddInventoryDialog = false
      this.editInventoryData = null
    },

    closeAddEmpInventoryDialog() {
      this.showAddEmpInventoryDialog = false
      this.editEmpInventoryData = null
      if (this.activeTab === 'EmployeeInventory') {
        const component = this.$refs[this.activeTab]
        if (component && component[0] && component[0].$refs.inventoryTable) {
          component[0].$refs.inventoryTable.getDataFromApi()
        }
      }
    },

    handleRequestAddEmpInventory() {
      this.showAddEmpInventoryDialog = true
      this.editEmpInventoryData = null
    },

    handleRequestEditEmpInventory(empInventoryData) {
      this.editEmpInventoryData = empInventoryData
      this.showAddEmpInventoryDialog = true
    },

    handleRequestCloseAddEmpInventory() {
      this.showAddEmpInventoryDialog = false
      this.editEmpInventoryData = null
    }
  },

  mounted() {
    if (!this.$route.query.activeTab && this.defaultTabKey) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: this.defaultTabKey }
      })
    }

    this.$nextTick(() => {
      this.isLoad = false
      this.$nextTick(() => {
        this.detectTabButtons(this.activeTab)
      })
    })
  }
}
</script>

<style scoped>
.v-dialog > .v-card > .v-card__title {
  padding: 16px !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0px !important;
}
.form-title {
  font-size: var(--font-heading);
  font-weight: var(--font-weight-semibold);
  padding: 0px;
  color: #21427d;
  margin: 0;
}
.v-dialog {
  overflow-y: hidden;
}
/* .v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: 16px;
}

.v-btn {
  text-transform: none !important;
  font-size: 12px;
} */
</style>
